import {
  icons_exports
} from "./chunk-AOQHDR27.js";
import {
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/components/Icon/types.tsx
var iconMap = __spreadValues({}, icons_exports);

export {
  iconMap
};
